var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentImage)?_c('div',{staticClass:"detail-toolbar"},[_c('div',[(false)?_c('span',[_vm._v(_vm._s(_vm.currentImage.id))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.currentImage.title))])]),_c('div',[(!_vm.readonly)?_c('el-button',{attrs:{"size":"mini"}},[_vm._v("编辑")]):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }